/**
 * Los contadores por estado que se muestran encima de la tabla de
 * postulaciones, y que ademas sirven de filtro al hacerles clic.
 *
 * Estaban escritos uno por uno en el JSX, y los numeros venian de unos estados
 * aparte del hook que solo se recalculaban al buscar: si se aceptaba o se
 * rechazaba una propuesta desde el modal, la lista cambiaba y los contadores
 * no. Teniendolos aqui, el numero y lo que muestra el filtro salen de la misma
 * definicion y de la misma lista.
 */
import { ChipEstado, NEUTRO, contarPorChip, filtrarPorChip } from "./chipsEstado";

export type { ChipEstado } from "./chipsEstado";
export { colorDeFondo } from "./chipsEstado";

/** En las postulaciones el estado vive en este campo. */
const CAMPO = "estado";

/** El chip que no filtra nada; tambien es el estado inicial de la pantalla. */
export const CLAVE_TODAS = "total";

export const CHIPS_ESTADO: ChipEstado[] = [
  {
    clave: "anulados",
    etiqueta: "Anulado",
    estados: ["Anulado"],
    clase: "font-color-0051E6",
    claseNumero: "font-color-0051E6",
    color: "#0051E6",
  },
  {
    clave: "completar",
    etiqueta: "Por completar",
    estados: ["Por completar"],
    clase: "",
    claseNumero: "font-color-black",
    color: NEUTRO,
  },
  {
    clave: "evaluado",
    etiqueta: "Evaluado",
    estados: ["Evaluado"],
    clase: "font-color-6435C9",
    claseNumero: "font-color-6435C9",
    color: "#6435C9",
  },
  {
    clave: "porEvaluar",
    etiqueta: "Por evaluar",
    estados: ["Por evaluar"],
    clase: "font-color-F28C02",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
  {
    clave: "rechazado",
    etiqueta: "Rechazado",
    estados: ["Rechazado"],
    clase: "font-color-DB2828",
    claseNumero: "font-color-DB2828",
    color: "#DB2828",
  },
  {
    clave: "subsanado",
    etiqueta: "Subsanado",
    estados: ["Subsanado"],
    clase: "font-color-6435C9",
    claseNumero: "font-color-6435C9",
    color: "#6435C9",
  },
  {
    clave: "subsanar",
    etiqueta: "Subsanar",
    estados: ["Subsanar"],
    clase: "font-color-F28C02",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
  {
    // En la base conviven los dos nombres para lo mismo.
    clave: "inscritos",
    etiqueta: "Inscritos sin revisar",
    estados: ["Inscrito sin revisar", "Sin revisar"],
    clase: "",
    claseNumero: "font-color-black",
    color: NEUTRO,
  },
  {
    clave: "aceptado",
    etiqueta: "Aceptado",
    estados: ["Aceptado"],
    clase: "font-color-00904C",
    claseNumero: "font-color-00904C",
    color: "#00904C",
  },
  {
    clave: "beneficiarios",
    etiqueta: "Beneficiarios",
    estados: ["Beneficiario"],
    clase: "font-color-00904C",
    claseNumero: "font-color-00904C",
    color: "#00904C",
  },
  {
    clave: CLAVE_TODAS,
    etiqueta: "Total",
    estados: null,
    clase: "",
    claseNumero: "font-color-F28C02",
    color: "#F28C02",
  },
];

/** Las postulaciones que le corresponden a un chip. */
export const postulacionesDelChip = (
  postulaciones: any[],
  clave?: string | null
): any[] => filtrarPorChip(postulaciones, CHIPS_ESTADO, clave, CAMPO);

/** Cuantas postulaciones le corresponden a un chip. */
export const contarChip = (
  postulaciones: any[],
  clave?: string | null
): number => contarPorChip(postulaciones, CHIPS_ESTADO, clave, CAMPO);
